// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'


import axios from 'axios';
import qs from 'qs';
import $ from 'jquery';
import mod from './js/public.js';
import anime from 'animejs'
import Meta from "vue-meta";
import './css/font.css';

import vuescroll from 'vuescroll';

import './css/reset.css';
import '../node_modules/swiper/swiper-bundle.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade, EffectFlip } from 'swiper';
import Vue from 'vue'
import Index from './Index'
import router from './router'
import VueAnimateNumber from 'vue-animate-number'
import layer from "layui-layer";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade, EffectFlip]);


Vue.prototype.$ajax = axios
Vue.prototype.$qs = qs
Vue.prototype.mod = mod
// Vue.prototype.$store = store
// Vue.use(MetaInfo)
Vue.use(Meta);

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(VueAwesomeSwiper),
  Vue.use(ElementUI, { locale });
Vue.use(VueAnimateNumber)
new Vue({
  el: '#index',
  router,
  components: { Index },
  template: '<index/>'
})



// WEBPACK FOOTER //
// ./src/main.js